/**
 * Ключи ленты событий для i18n (§22.2, §19.5).
 */

import type { FeedEventView } from "../api/feed.js";

const KNOWN_KINDS = new Set([
  "ritual.capture",
  "hearth.placed",
  "tribute.paid",
  "tribute.received",
  "debt.penalty",
  "debt.stage",
]);

export type FeedEventParams = {
  kind: string;
  tierLabel?: string;
  fromTierLabel?: string;
  toTierLabel?: string;
  [key: string]: string | number | undefined;
};

export function feedEventI18nKey(kind: string): string {
  return KNOWN_KINDS.has(kind) ? `event.${kind}` : "event.unknown";
}

export function feedEventParams(
  event: FeedEventView,
  tierLabel: (tier: string) => string,
): FeedEventParams {
  const params: FeedEventParams = { kind: event.kind };
  for (const [key, value] of Object.entries(event.params)) {
    if (typeof value === "string" || typeof value === "number") {
      params[key] = value;
    }
  }
  const tier = params["tier"];
  if (event.kind === "debt.penalty" && typeof tier === "string") {
    params.tierLabel = tierLabel(tier);
  }
  const fromTier = params["fromTier"];
  const toTier = params["toTier"];
  if (event.kind === "debt.stage") {
    if (typeof fromTier === "string") {
      params.fromTierLabel = tierLabel(fromTier);
    }
    if (typeof toTier === "string") {
      params.toTierLabel = tierLabel(toTier);
    }
  }
  return params;
}
